// Lingue supportate dai contenuti localizzati dei tool (scheda dettaglio a
// blocchi e guide PDF). Elenco centralizzato ed estendibile: per aggiungere una
// nuova lingua basta inserire una riga qui — l'editor admin mostrerà un sotto-tab
// per ciascuna, e il resto della pipeline (tabella ToolDetailedDescriptions per
// codice lingua, risoluzione lato tools) la gestisce senza altre modifiche.
export interface SupportedLanguage {
  code: string;   // codice ISO minuscolo, es. "it", "en", "de"
  label: string;  // etichetta mostrata in UI
}

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  { code: 'it', label: 'Italiano' },
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
  { code: 'de', label: 'Deutsch' },
];

/** Etichetta di una lingua dal codice; fallback al codice in maiuscolo se sconosciuta. */
export const languageLabel = (code: string): string =>
  SUPPORTED_LANGUAGES.find(l => l.code === code)?.label ?? code.toUpperCase();
